import React from 'react';
import cls from 'classnames';
import Img from '~/components/Elements/Img';

export const V360Thumbnail = React.forwardRef(({
	className,
	classes,
    active,
    data,
    ...props
}, ref) => {
	const rootRef = React.useRef();

	React.useImperativeHandle(ref, () => ({
		root: rootRef.current,
	}));

	return (
		<div
			{...props}
			ref={rootRef}
			className={cls(classes.thumbnail, className, {
				[classes.isActive]: active,
			})+" btntrack_"+data.name}>
			<div className={cls(classes.thumbnailBox)}>
				<div className={cls(classes.thumbnailFigure)}>
					<Img
						className={cls(classes.thumbnailImage)}
						src={data.icon}
						alt={data.alt}
						width={226}
						height={212}
					/>
					<span
						className={cls(classes.thumbnailCaption)}
						dangerouslySetInnerHTML={{
							__html: data.name,
						}}
					/>
				</div>
			</div>
		</div>
	);
});

export default React.memo(V360Thumbnail);
